import { mapState, mapGetters } from 'vuex';
import TableList from "@components/templates/tablelist";
import {
    HttpGetReplenishList,
    HttpReplenishDelete
} from "@/service/products/replenish";
import compUpdate from "./update";
export default {
    mixins: [TableList],
    components: {
        compUpdate
    },
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Tabs: { show: true },
            formData: {
                search: {
                    // EQ_status: 1
                },
            },
            Searchs: {
                show: true,
                labelWidth: 110,
            },
            Plugins: { show: true },
        }
    },
    methods: {
        ajaxRequest: HttpGetReplenishList,
        // interceptRequest(params) {
        //     return this.handleParams(params);
        // },
        // handleParams(params) {
        //     return {
        //         ...params,
        //         search: {
        //             ...params.search,
        //             EQ_status: 1
        //         }
        //     };
        // },
        getOperateNodeMap(row) {
            const { id } = row
            return [
                {
                    label: '查看',
                    show: true,
                    params: id,
                    operate: 'query'
                },
                {
                    label: "编辑",
                    show: true,
                    params: id,
                    operate: 'edit'
                },
                {
                    label: "删除",
                    show: true,
                    params: id,
                    operate: 'delete'
                }
            ]
        },
        handleOperates(params = "", type, batch) {
            if (batch === true) {
                params = (params || this.checkedData.join(',')) + '';
                if (!params.length) return this.$VMessage.warning('请选择至少一条数据');
            }
            switch (type) {
                case "query":
                    this.operate = {
                        show: true,
                        title: "查看",
                        width: 800,
                        activeid: params,
                        querytype: "query",
                        showFooter: false,
                        component: "compUpdate"
                    }
                    break;
                case "add":
                    // {
                    //     this.$router.push({
                    //         name: 'replenishUpdate',
                    //         params: { type: "add" },
                    //         // query: { id: params },
                    //     });
                    // }
                    this.operate = {
                        show: true,
                        title: "添加",
                        width: 800,
                        // activeid: params,
                        querytype: "add",
                        showFooter: false,
                        component: "compUpdate"
                    }
                    break;
                case "edit":
                    {
                        // let url = this.$router.resolve({
                        //     name: "replenishUpdate",
                        //     params: { type: "edit" },
                        //     query: { id: params },
                        // });
                        // window.open(url.href, '_blank');
                        this.operate = {
                            show: true,
                            title: "编辑",
                            width: 800,
                            activeid: params,
                            querytype: "edit",
                            showFooter: false,
                            component: "compUpdate"
                        }
                    }
                    break;
                case "delete":
                    {
                        this.operate = {
                            show: true,
                            alert: "warning",
                            title: "删除",
                            params: { id: params },
                            showFooter: true,
                            ajaxRequest: HttpReplenishDelete,
                        }
                    }
                    break;
                case "import":
                    {
                        this.operate = {
                            show: true,
                            width: 450,
                            title: "导入",
                            showDesc: false,
                            component: "compUpload",
                            name: "excelFile",
                            showFooter: false,
                            action: process.env.VUE_APP_APIURL_BOSS + "/api/v2/productReplenishmentRule/import",
                            download: () => {
                                this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + '/api/v2/productReplenishmentRule/excel', {}, 'download')
                            },
                        }
                    }
                    break;
                case "export":
                    this.handleWebfs(process.env.VUE_APP_APIURL_BOSS + "/api/v2/productReplenishmentRule/exportByFilter", this.formData, 'download');
                    break;
            }
        }
    },
    computed: {
        ...mapGetters('diction', ['getNewProductList']),
        ToolsData() {
            return [
                {
                    name: "添加",
                    operate: "add",
                    theme: "primary",
                },
                {
                    name: "批量导入",
                    operate: "import",
                    theme: "success",
                },
                {
                    name: "批量删除",
                    operate: "delete",
                    theme: "warning",
                    batch: true,
                },
                {
                    name: "查询条件导出",
                    operate: "export",
                    theme: "info",
                }
            ]
        },
        SearchsData() {
            return [
                {
                    label: "ERP SKU",
                    key: "EQ_sku",
                    tag: 'div',
                    show: true,
                    removeInput: true,
                    children: (h) => {
                        return h('compErpSkuInput', {
                            props: {
                                value: this.formData.search.EQ_erpSku,
                                showread: "showyes"
                            },
                            on: {
                                'on-data': (row) => {
                                    this.formData.search.EQ_erpSku = row.erpSku;
                                },
                            }
                        })
                    }
                },
                {
                    label: "项目",
                    key: "IN_lineId",
                    tag: "vSelect",
                    props: {
                        filterable: true,
                        multiple: true
                    },
                    options: this.getNewProductList,
                    show: true
                },
                {
                    label: "补货ERP SKU",
                    key: "EQ_reErpSku",
                    tag: 'div',
                    show: true,
                    removeInput: true,
                    children: (h) => {
                        return h('compErpSkuInput', {
                            props: {
                                value: this.formData.search.EQ_reErpSku,
                                showread: "showyes"
                            },
                            on: {
                                'on-data': (row) => {
                                    this.formData.search.EQ_reErpSku = row.erpSku;
                                },
                            }
                        })
                    }
                },
            ]
        },
        columns() {
            return [
                {
                    type: "selection",
                    formName: "id",
                    width: 50,
                },
                {
                    title: '操作',
                    width: 70,
                    render: this.getOperateNodes,
                },
                {
                    title: "ERP SKU",
                    key: "erpSku",
                },
                {
                    title: "项目",
                    key: "lineId",
                    render: (h, { row }) => {
                        let lineItem = this.getNewProductList.filter(item => {
                            return item.value == row.lineId;
                        })[0];
                        return lineItem ? lineItem.label : "--";
                    }
                },
                {
                    title: "补货ERP SKU",
                    key: "reErpSku"
                },
                {
                    title: "数量比",
                    key: "quantity"
                },
                {
                    title: "创建时间",
                    key: "createdAt"
                },
                {
                    title: "更新时间",
                    key: "updatedAt"
                }
            ]
        }
    }
}